import { UploadDataReference, UploadType } from '../../../../shared/components/upload-files';

/**
 * The request items an upload targets, read from the reference its job carries in
 * shared upload state — so it resolves for as long as the job exists, whichever
 * view started it.
 *
 * Empty for a list-level bulk drop: those files belong to the request until the
 * backend categorizes them onto an item.
 */
export function crlUploadItemIds(entityData: UploadDataReference): readonly number[] {
  if (entityData.uploadType === UploadType.CLIENT_REQUEST_SUBMISSION) {
    return entityData.requestItemIds ?? [];
  }
  if (entityData.uploadType === UploadType.CLIENT_REQUEST_REPLACE) {
    return [entityData.clientRequestItemId];
  }
  return [];
}

/** Whether an upload was started against this request item. */
export function isCrlUploadForItem(entityData: UploadDataReference, itemId: number): boolean {
  return crlUploadItemIds(entityData).includes(itemId);
}

/** Whether an upload belongs to this request and names an item within it. */
export function isItemScopedCrlUpload(entityData: UploadDataReference, requestId: number): boolean {
  const isCrlContext =
    entityData.uploadType === UploadType.CLIENT_REQUEST_SUBMISSION ||
    entityData.uploadType === UploadType.CLIENT_REQUEST_REPLACE;

  return isCrlContext && entityData.clientRequestId === requestId && crlUploadItemIds(entityData).length > 0;
}
